import { useQuery } from '@tanstack/react-query'
import { api, type Case } from '@/services/api'

export const casesQueryKey = ['cases', 'list'] as const

/** The current user's case list. */
export function useCases() {
  return useQuery<Case[]>({ queryKey: casesQueryKey, queryFn: () => api.cases.list() })
}
